import type {
  EmergencyAssignmentFirestoreRecord,
  EmergencyResponder,
  EmergencyResponderState,
} from '@src/models/interfaces/emergency.interface';
import { EMERGENCY_RESPONDER_STATES } from '@src/models/interfaces/emergency.interface';
import { DateUtil } from '@src/packages/utils/dates';
import { resolveUserDisplayName } from '@src/packages/utils/user';

import { asBoolean, asRecord, asString } from './emergencyMapper.utils';

export class EmergencyAssignmentMapper {
  static fromFirestore(record: EmergencyAssignmentFirestoreRecord): EmergencyResponder {
    const responder = asRecord(record.responder);
    const state = Object.values(EMERGENCY_RESPONDER_STATES).includes(
      record.state as EmergencyResponderState,
    )
      ? (record.state as EmergencyResponderState)
      : EMERGENCY_RESPONDER_STATES.INVITED;

    return {
      assignmentId: record.id,
      userId: asString(responder.id),
      displayName: resolveUserDisplayName(
        {
          firstName: asString(responder.firstName),
          lastName: asString(responder.lastName),
          displayName: asString(responder.displayName),
        },
        '',
      ),
      state,
      primary: asBoolean(record.primary),
      stateUpdatedAt: DateUtil.toDateOrNull(record.updatedAt),
    };
  }
}
